import { Typography, makeStyles } from "@material-ui/core";

import React from "react";
import classNames from "classnames";
import { get } from "lodash";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "right",
    marginRight: theme.spacing(4),
    minWidth: 100,
  },
  complete: {
    color: theme.palette.success.main,
    fontWeight: "bold",
  },
  incomplete: {
    color: theme.palette.warning.main,
    fontWeight: "bold",
  },
  total: {
    paddingRight: theme.spacing(2),
  },
}));
const RangeField = ({ record, sortBy, basePath, ...props }) => {
  const translate = useTranslate();
  const classes = useStyles();
  const status = get(record, "status", "incomplete");
  return (
    <Typography
      {...props}
      className={classNames(record?.id === 0 && classes[status], classes.root)}
    >
      {record?.id === 0 &&
        translate("resources.research-project-activities.total")}
      {record?.id === 0 && <span>&nbsp;</span>}

      {get(record, "from_month")}
      {get(record, "from_month") !== get(record, "to_month") && " - "}
      {get(record, "to_month") !== get(record, "from_month")
        ? get(record, "to_month")
        : ""}
    </Typography>
  );
};
export default RangeField;
